import { isFunction, some, isEmpty } from 'underscore';
import { merge } from '@bingads-webui/primitive-utilities';
import {
  campaignSettingsStyles, adgroupsKeywordsStyles, adExtensionsStyles, budgetBidsStyles, adgroupCreationStyles,
  creationCommonStyle,
  dsaCampaignStyles,
  audienceCampaignSettingsStyles, audienceTargetsSettingsStyles, audienceBudgetBidsStyles, audienceAdsStyles,
  audienceAdgroupStyles,
  raiseBidPopupStyles,
  disclaimerPanelStyles, globalDsaCampaignStyles,
  globalAdgroupCreationStyles,
  audienceCampaignBmcRedirectStyles
} from '@bingads-webui-campaign-react/campaign-adgroup-settings-shared-styles';
import {
  entitySelectorStyle, uiblockerStyle, toggleButtonStyle, messageBarStyle, searchboxStyle, tableStyle,
  helpbuttonStyle, linkStyle, paginationStyle, statusStyle, glyphIconStyle, kendoMultiSelectStyle, commonDoubleListBoxStyle,
  advancedSettingsSectionStyle, containerBudgetStyle, locationBidGridStyle, keywordPlannerStyle, locationMapStyle,
  sharedBudgetGridWrapper, estimationResultStyle, audienceAssociationSectionStyle, extensionEditorStyles, audienceReachEstimateContainerStyle,
  datePickerStyle, audienceModalStyles, audienceCombinedListStyle, keywordToolbarStyle, selectElementStyle, buttonInputStyle, inputFieldStyle, audienceExpressionStyle,
  convertToGlobalStyle, legacyUIBlockerStyle
} from '@bingads-webui-campaign-react/common-styles';
import { adEditorPanelOverrideStyle } from '@bingads-webui-campaign-react/ad-editor-styles';
import { stepWizardStyle } from './step-wizard';
import { getCreationContainerContentStyle, CreationContainerContentOverrideStyle } from './creation-content-container-style';

function resolveStyles(theme, ...styles) {
  const resolvedStyles = styles.map(s => (isFunction(s) ? s(theme) : s));

  if (some(resolvedStyles, isEmpty)) {
    throw new Error('Cannot pass in empty style!');
  }
  return resolvedStyles;
}

export const getAdgroupCreationAudienceStyle = (_, { palette = {} }) => {
  const commonStyles = merge(
    {},
    ...resolveStyles(
      { palette },
      statusStyle,
      paginationStyle,
      entitySelectorStyle,
      buttonInputStyle,
      containerBudgetStyle,
      commonDoubleListBoxStyle,
      keywordPlannerStyle,
      searchboxStyle,
      estimationResultStyle,
      locationBidGridStyle,
      locationMapStyle,
      sharedBudgetGridWrapper,
      tableStyle,
      advancedSettingsSectionStyle,
      toggleButtonStyle,
      linkStyle,
      selectElementStyle
    )
  );

  const globalStyles = merge(
    {},
    ...resolveStyles(
      { palette },
      stepWizardStyle,
      uiblockerStyle,
      kendoMultiSelectStyle,
      audienceModalStyles,
      audienceExpressionStyle,
      audienceCombinedListStyle,
      extensionEditorStyles,
      messageBarStyle,
      glyphIconStyle,
      datePickerStyle,
      helpbuttonStyle,
      keywordToolbarStyle,
      inputFieldStyle,
      CreationContainerContentOverrideStyle,
      disclaimerPanelStyles,
      globalDsaCampaignStyles,
      globalAdgroupCreationStyles
    ),
    convertToGlobalStyle(resolveStyles(
      { palette },
      adEditorPanelOverrideStyle
    ))
  );


  const searchCreationStyles = merge(
    {},
    ...resolveStyles(
      { palette },
      audienceTargetsSettingsStyles,
      audienceBudgetBidsStyles,
      dsaCampaignStyles,
      campaignSettingsStyles,
      adgroupsKeywordsStyles,
      adExtensionsStyles,
      budgetBidsStyles,
      creationCommonStyle,
      adgroupCreationStyles,
      raiseBidPopupStyles
    )
  );

  const audienceCreationStyles = merge(
    {
      '& .ima-reach-alert': {
        padding: '8px 32px 8px 8px !important',
        marginTop: '10px',
        marginLeft: '0px',
      },
    },
    ...resolveStyles(
      { palette },
      audienceCampaignSettingsStyles,
      audienceReachEstimateContainerStyle,
      audienceAssociationSectionStyle,
      audienceTargetsSettingsStyles,
      audienceBudgetBidsStyles,
      audienceAdsStyles,
      audienceAdgroupStyles,
      audienceCampaignBmcRedirectStyles,
      legacyUIBlockerStyle
    )
  );

  return {
    '@global': globalStyles,

    CampaignCreationAudience: {
      ...getCreationContainerContentStyle(),
      ...audienceCreationStyles,
      ...commonStyles,
      ...searchCreationStyles,
    },
  };
};
